import { fetchCounters } from './actionCounterBaseProvider'
import { snakeKeysToCamel } from './../../utils/object'

const USER_PREFIX = 'User'
const getUserKey = id => `${USER_PREFIX}_${id}`

export const fetchUserActionCounter = ({ userId }) =>
  fetchCounters([getUserKey(userId)]).then(snakeKeysToCamel)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/actionCounter/userActionCounterProvider.js